import {useMemo} from 'react';
import {AssetWorkflow} from '@taopix/taopix-asset-manager';
import {useUploader} from '../../Components/Context/Upload/UploadContext';
import {useTaopix} from '../../Components/Context/TaopixContext';

const useStatusChecker = (workflow?: AssetWorkflow) => {
  const taopix = useTaopix();
  const uploader = useUploader();

  const monitor = useMemo(() => {
    if (0 === Object.keys(uploader).length || !taopix.state.loaded) return;

    return uploader.getMonitor(
      {
        code: '%TAOPIXONLINE%',
      },
      workflow ? workflow : AssetWorkflow.DEFAULT
    );
  }, [uploader]);

  return monitor;
};

export default useStatusChecker;
